import { useState } from 'react';
import { OohPoint } from '../../../../core/graphql/types';
import { ChevronDown, ChevronUp } from 'lucide-react';

export interface RouteCapacityCardProps {
  routeName: string;
  pickupPoints: OohPoint[];
  courierIndicatives: string[];
}

const RouteCapacityCard = ({
  routeName,
  pickupPoints,
  courierIndicatives,
}: RouteCapacityCardProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const sortedPoints = [...pickupPoints].sort((a, b) =>
    a.name!.localeCompare(b.name!),
  );

  const totalCapacity = sortedPoints.reduce(
    (sum, point) => sum + point.capacity,
    0,
  );

  return (
    <div className="border-1 mb-4 border p-4 shadow-md dark:text-white">
      <div className="mb-2 flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-wrap items-center gap-2">
          <h2 className="text-lg font-semibold">{routeName}</h2>
          {courierIndicatives.map((courier, idx) => (
            <span
              key={idx}
              className="rounded-full bg-darker-red px-2 py-0.5 text-xs font-medium text-white"
            >
              {courier}
            </span>
          ))}
        </div>
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="flex-shrink-0 rounded p-1 transition-colors duration-200 hover:bg-bright-blue/30 dark:hover:bg-bright-blue/30"
        >
          {isExpanded ? (
            <ChevronUp className="h-4 w-4 dark:text-white" />
          ) : (
            <ChevronDown className="h-4 w-4 dark:text-white" />
          )}
        </button>
      </div>

      {isExpanded && (
        <ul className="border-gray-700 mt-2 max-h-96 overflow-y-auto border-t border-b pt-2">
          {sortedPoints.map((point, idx) => (
            <li
              key={idx}
              className="border-gray-700 flex justify-between py-1 last:border-b-0"
            >
              <span>{point.name}</span>
              <span className="font-medium">{point.capacity}</span>
            </li>
          ))}
        </ul>
      )}

      <div className="mt-2 flex w-full justify-between text-sm">
        <span className="font-semibold dark:text-white">{`Total capacity`}</span>
        <span className="mr-1 font-semibold dark:text-white">
          {totalCapacity}
        </span>
      </div>
    </div>
  );
};

export default RouteCapacityCard;
